import { CombinedModel } from "./models/combinedModel.models";
import axiosInstance from "./axios";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

const getCombinedByModel = async (
  bearerToken: string,
  payload: {
    companyId: string;
    modelId: string;
  }
): Promise<CombinedModel> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Products/${payload.companyId}/packagerows/combineByModel/${payload.modelId}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch combined model:", error);
    throw error;
  }
};

export const combinedModelApi = {
  getCombinedByModel,
};
